/**************************************************
 * Nombre:       Formulario_Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {ArrowForward, MailOutline} from "@mui/icons-material";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";

const Formulario_Home_Portada = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'felx-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTextoBoton Icono={MailOutline} nombre={'Correo Electronico'} dato={'correo'} {...props}
                                       IconoFinal={ArrowForward} click={props.click}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Home_Portada